"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapLinkButton = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const slate_react_1 = require("slate-react");
const Yup = __importStar(require("yup"));
const Link_1 = __importDefault(require("@material-ui/icons/Link"));
// utils
const wrap_link_1 = require("../utils/wrap-link");
const button_styles_1 = require("./button-styles");
// types
const slate_1 = require("slate");
const files_context_1 = require("../../../common/files/files-context");
const prompt_context_1 = require("../../../composite/prompt/prompt-context");
const prompt_register_hook_1 = require("../../../composite/prompt/prompt-register-hook");
const form_file_field_1 = require("../../../composite/form/fields/form-file-field");
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
const PROMPT_KEY = 'LINK_OPTIONS';
function WrapLinkButton() {
    var _a;
    const classes = button_styles_1.useStyles();
    const editor = slate_react_1.useSlate();
    const { getFileUrl } = react_1.useContext(files_context_1.FilesContext);
    const { testPrompt } = react_1.useContext(prompt_context_1.PromptContext);
    const initUrl = react_1.useRef();
    const initFileRef = react_1.useRef();
    const mark = slate_1.Editor.marks(editor);
    react_1.useEffect(() => {
        var _a, _b, _c, _d, _e;
        if ((_a = mark === null || mark === void 0 ? void 0 : mark.link) === null || _a === void 0 ? void 0 : _a.url) {
            const regex = /\/api\/crzp\/files\/(?<id>.*)/;
            const result = (_b = mark === null || mark === void 0 ? void 0 : mark.link) === null || _b === void 0 ? void 0 : _b.url.match(regex);
            if ((_c = result === null || result === void 0 ? void 0 : result.groups) === null || _c === void 0 ? void 0 : _c.id) {
                initUrl.current = undefined;
                initFileRef.current = {
                    id: (_d = result === null || result === void 0 ? void 0 : result.groups) === null || _d === void 0 ? void 0 : _d.id,
                    name: mark.link.name,
                    contentType: mark.link.contentType,
                    size: parseInt(mark.link.size, 10),
                };
            }
            else {
                initUrl.current = (_e = mark === null || mark === void 0 ? void 0 : mark.link) === null || _e === void 0 ? void 0 : _e.url;
                initFileRef.current = undefined;
            }
        }
    }, [(_a = mark === null || mark === void 0 ? void 0 : mark.link) === null || _a === void 0 ? void 0 : _a.url]);
    prompt_register_hook_1.usePrompts([
        {
            key: PROMPT_KEY,
            dialogTitle: 'Vložit odkaz',
            dialogText: 'Určite chcete vytvoriť link?',
            FormFields: function Body() {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(form_text_field_1.FormTextField, { label: "URL adresa", name: "url" }),
                    react_1.default.createElement(form_file_field_1.FormFileField, { label: "Soubor", name: "file" })));
            },
            formInitialValues: {
                url: initUrl.current,
                file: initFileRef.current,
            },
            formValidationSchema: Yup.object().shape({
                url: Yup.mixed().when('file', {
                    is: (file) => !file,
                    then: Yup.mixed().required('1 z polí "URL adresa" / "Soubor" je povinné'),
                    otherwise: Yup.mixed().notRequired(),
                }),
                file: Yup.mixed().when('url', {
                    is: (url) => !url,
                    then: Yup.mixed().required('1 z polí "URL adresa" / "Soubor" je povinné'),
                    otherwise: Yup.mixed().notRequired(),
                }),
            }, [['url', 'file']]),
        },
    ], [initUrl.current, initFileRef.current]);
    const disabled = !editor.selection || slate_1.Range.isCollapsed(editor.selection);
    return (react_1.default.createElement("button", { disabled: disabled, onMouseDown: (event) => {
            event.preventDefault();
            const selection = editor.selection;
            testPrompt({
                key: PROMPT_KEY,
                submitCallback: async ({ url, file, }) => {
                    if (file === null || file === void 0 ? void 0 : file.id) {
                        wrap_link_1.wrapLink(editor, selection, {
                            url: getFileUrl(file.id),
                            name: file.name,
                            contentType: file.contentType,
                            size: file.size,
                        });
                    }
                    else {
                        wrap_link_1.wrapLink(editor, selection, { url });
                    }
                },
            });
        }, className: clsx_1.default(classes.button, {
            [classes.disabled]: disabled,
        }) },
        react_1.default.createElement(Link_1.default, { fontSize: "small", titleAccess: "vlo\u017Eit odkaz" })));
}
exports.WrapLinkButton = WrapLinkButton;
//# sourceMappingURL=wrap-link-button.js.map